<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row" v-if="userData.permissions['view_runningloans'] == 1 && userData.permissions['view_loans'] == 1">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <span class="d-flex justify-content-between mb-2">
              <div class="d-flex justify-content-between">
                <div>
                  <label>From</label><input class="form-control" v-model="date_from" type="date" />
                </div>
                <div class="mx-1">
                  <label>To</label><input class="form-control" v-model="date_to" type="date" />
                </div>
                <div class="mt-4">
                  <b-button variant="primary" @click="FilterData"><i class="mdi mdi-filter"></i>
                    Filter</b-button>
                </div>
              </div>
            </span>
            <div class="clearfix"></div>
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show
                    <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm"
                      :options="Options"></b-form-select>
                    entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input v-model="filter" type="search" placeholder="Search..."
                      class="form-control form-control-sm ms-2"></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <b-table :items="Items" :fields="Fields" responsive="sm" :per-page="perPage" :current-page="currentPage"
                :filter="filter" :filter-included-fields="filterOn" @filtered="Filtered" :busy="IsBusy">
                <template #table-busy>
                  <div class="text-center text-primary my-2">
                    <b-spinner class="align-middle" type="grow" small></b-spinner>
                    <strong>No Data Found</strong>
                  </div>
                </template>
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(member)="data">
                  <router-link :to="{
                    path: '/memberprofile',
                    query: { id: data.item.member.member_id },
                  }">
                    <span @mouseover="name_hover = true; current_index = data.index" @mouseout="name_hover = false">
                      <span
                        :class="(name_hover && current_index == data.index) ? 'fw-bold text-dark text-decoration-underline' : 'text-dark'">{{
                          data.item.member.name }}</span>
                      <span class="d-block text-info fw-bold">{{ data.item.member.member_id }}</span>
                    </span>
                  </router-link>
                </template>
                <template #cell(loan_type)="data">
                  <b><span class="text-info">{{
                    data.item.loan_type.name
                      }}</span>
                    <br />
                    <small>{{
                      data.item.loan_type.rate
                      }}%</small>
                    &nbsp;&nbsp;&nbsp;
                    <small>{{
                      data.item.loan_type.period
                      }}days</small></b>
                </template>
                <template #cell(amount)="data">
                  {{ commas(data.item.amount) }}
                </template>
                <template #cell(interest)="data">
                  <span v-if="userData.settings.combine_interest_fine == '1'">

                    {{ commas(data.item.interest) }}
                    <small class="d-block text-danger" v-if="data.item.fine > 0">+{{ commas(data.item.fine) }}</small>
                  </span>
                  <span v-else>
                    {{ commas(data.item.interest) }}

                  </span>
                </template>


                <template #cell(expirydate)="data">
                  <span>{{ data.item.expirydate }}</span>
                  <br />
                  <small v-if="data.item.daysleft < 1" class="bg-danger text-white px-1 rounded-1">
                    {{ Math.abs(data.item.daysleft) }}
                    day(s) passed</small>
                  <small class="bg-primary text-white px-1 rounded-1" v-else>
                    {{ data.item.daysleft }} day(s)
                    left</small>
                </template>
                <template #cell(repaymentplan)="data">
                  {{ commas(data.item.repaymentplan) }}
                  <small class="text-info">/</small>
                  {{ data.item.repaymentstructure }}
                </template>
                <template #cell(paid)="data">
                  {{ commas(data.item.paid) }}
                </template>

                <template #cell(fine)="data">
                  <span class="text-danger fw-bold">{{
                    data.item.fine > 0
                      ? commas(data.item.fine)
                      : "0"
                  }}</span>
                </template>

                <template #cell(balance)="data">
                  <span v-if="
                    data.item.amount +
                    data.item.interest +
                    data.item.fine -
                    data.item.paid <=
                    0
                  ">
                    <small class="d-block text-info">
                      <i class="mdi mdi-check-circle"></i>
                      Paid</small>
                      <button class="btn btn-sm btn-info" v-show="userData.permissions['repayaloan']" @click="
                      closeloan(
                        data.item.id,
                        data.item.member.name,
                        data.item.amount,
                        data.item.interest,
                        data.item.fine
                      )
                      " title="Close Running Loan" v-b-modal.edit>
                    Close</button>
                  </span>
                  <span v-else>
                    {{
                      commas(Number(data.item.amount) +
                        Number(data.item.interest) +
                        Number(data.item.fine) -
                        Number(data.item.paid))
                    }}
                    <br />
                    <b-button v-show="userData.permissions[
                      'repayaloan'
                    ] == 1
                      " @click="
                        payaLoan(
                          data.item.id,
                          data.item.member,
                          data.item.amount,
                          data.item.interest,
                          data.item.fine,
                          data.item.paid
                        )
                        " type="button" class="btn-sm" variant="primary" title="Repay loan" v-b-modal.edit><i
                        class="mdi mdi-cash"></i>
                      Pay</b-button>
                  </span>
                </template>

                <template #cell(actions)="data">
                  <b-dropdown v-if="Number(data.item.amount) +
                    Number(data.item.interest) +
                    Number(data.item.fine) -
                    Number(data.item.paid) >
                    0
                  " size="sm" class="m-0" variant="link">
                    <template #button-content><i class="fas fa-ellipsis-v text-dark"></i></template>

                    <b-dropdown-item v-if="userData.permissions['reschedule_loan'] == 1" v-show="Number(data.item.amount) +
                      Number(data.item.interest) +
                      Number(data.item.fine) -
                      Number(data.item.paid) >
                      0
                      " @click="
                        reschedule(
                          data.item.id,
                          data.item.member.name,
                          data.item.amount,
                          data.item.interest,
                          data.item.fine
                        )
                        " type="button" variant="dark" title="Approve" v-b-modal.edit><i class="mdi mdi-calendar"></i>
                      Reschedule</b-dropdown-item>
                    <b-dropdown-item v-if="userData.permissions['write_off_loan']" v-show="Number(data.item.amount) +
                      Number(data.item.interest) +
                      Number(data.item.fine) -
                      Number(data.item.paid) >
                      0
                      " @click="
                        writeoff(
                          data.item.id,
                          data.item.member.name,
                          data.item.amount,
                          data.item.interest,
                          data.item.fine
                        )
                        " type="button" variant="danger" title="Approve" v-b-modal.edit><i
                        class="mdi mdi-close-circle"></i>
                      Write Off</b-dropdown-item>
                  </b-dropdown>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <b>Total Loans : {{ commas(totalloan) }}</b>
              </div>
              <div class="col text-center">
                <b>Total Paid : {{ commas(totalpaid) }}</b>
              </div>
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br /><br />
            <center>
              <span class="text-primary h6">You have no permission to view Running
                Loans</span>
            </center>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="repay-loan" centered title=" Repay a Loan" title-class="font-14" hide-footer size="lg">
      <form @submit.prevent="repayaLoan">
        <div class="form-group mb-3">
          <label class="m-0">Member</label>
          <input type="text" class="form-control text-info" style="background: none;" readonly v-model="membername" />
        </div>
        <div class="form-group mb-3">
          <label class="m-0">Payback</label>
          <input type="text" class="form-control text-info" style="background: none;" readonly v-model="total_loan" />
          <div>
            <br />
            <center class="fs-4 fw-bold">Balances</center>
            <div class="row">
              <div class="col-3">
                Loan:
                <span class="text-danger">{{
                  commas(bal_loan)
                  }}</span>
              </div>
              <div class="col-3">
                Interest:
                <span class="text-danger">{{
                  commas(bal_interest)
                  }}</span>
              </div>
              <div class="col-3">
                {{ userData.settings.combine_interest_fine == '1' ? 'Extra' : 'Fine' }}:
                <span class="text-danger">{{
                  (bal_fine > 0) ? commas(bal_fine) : 0
                  }}</span>
              </div>
              <div class="col-3">
                Change:
                <span class="text-success">{{
                  commas(extra_change)
                  }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-md-6">
            <label class="m-0">Amount Paid</label>
            <input type="number" class="form-control text-info" v-model="amount" @input.prevent="payFunction" />
          </div>
          <div class="col-md-6">
            <label class="m-0">Mode of Payment</label>
            <small class="text-danger">*</small>
            <v-select :options="paymentoptions" placeholder="Select an Option" v-model="mode_of_payment" label="name"
              :reduce="(mode_of_payment) => mode_of_payment.id" required></v-select>
          </div>
        </div>
        <div class="form-group mb-3">
          <label class="m-0">Reference</label>
          <textarea v-model="refference" rows="2" class="form-control"></textarea>
        </div>
        <div class="form-group mb-3">
          <label class="m-0">Payment Date</label>
          <input type="date" :max="currentdate" class="form-control text-info" v-model="paymentdate" />
        </div>
        <small class="text-danger">{{ saveError }}</small>
        <div class="form-group d-flex justify-content-end">
          <b-button type="button" class="btn w-30" variant="secondary"
            @click="$bvModal.hide('repay-loan')">Close</b-button>
          <b-button type="submit" :disabled="saveBtn" class="btn ms-1 w-30" variant="primary"><i
              class="fas fa-check-circle"></i> Submit</b-button>
        </div>
      </form>
    </b-modal>

    <b-modal id="close-a-loan" size="sm" centered title="Close a Loan Disbursement" title-class="font-18" hide-footer>
      <form @submit.prevent="Close_a_Loan">
        <input v-model="id" type="hidden" />
        <center>
          Are you sure you want to Close {{ membername }}`s loan of :
          <b>{{ commas(amount) }}</b>
          {{ userData.currency }} ?
        </center>
        <div class="form-group d-flex justify-content-end mt-3">
          <b-button type="button" class="btn w-30" variant="secondary"
            @click="$bvModal.hide('close-a-loan')">Close</b-button>
          <b-button type="submit" class="btn ms-1 w-30" variant="primary"><i class="fas fa-check-circle"></i>
            YES</b-button>
        </div>
      </form>
    </b-modal>

    <b-modal id="reschedule-a-loan" size="sm" centered title="Reschedule a Loan" title-class="font-18" hide-footer>
      <form @submit.prevent="Reschedule_a_Loan">
        <input v-model="id" type="hidden" />
        <center>
          Are you sure you want to Reschedule {{ membername }}`s loan
          of : <b>{{ commas(amount) }}</b>
          {{ userData.currency }} ?
        </center>
        <br /><label>Date</label>
        <input v-model="rescheduledate" type="date" :min="currentdate" class="form-control" />
        <label>Reason</label>
        <textarea v-model="reschedulereason" rows="2" class="form-control"></textarea>
        <div class="form-group d-flex justify-content-end mt-3">
          <b-button type="button" class="btn w-30" variant="secondary"
            @click="$bvModal.hide('reschedule-a-loan')">Close</b-button>
          <b-button type="submit" class="btn ms-1 w-30" variant="primary"><i class="fas fa-check-circle"></i>
            YES</b-button>
        </div>
      </form>
    </b-modal>

    <b-modal id="write-off-loan" size="sm" centered title="Write Off a Loan" title-class="font-18" hide-footer>
      <form @submit.prevent="Write_off_Loan">
        <input v-model="id" type="hidden" />
        <center>
          Are you sure you want to Write Off {{ membername }}`s loan
          of : <b>{{ commas(amount) }}</b>
          {{ userData.currency }} ?
        </center>
        <br /><label>Reason</label>
        <textarea v-model="writeoffreason" rows="2" class="form-control"></textarea>
        <label>Date</label>
        <input v-model="writeoffdate" type="date" class="form-control" />
        <div class="form-group d-flex justify-content-end mt-3">
          <b-button type="button" class="btn w-30" variant="secondary"
            @click="$bvModal.hide('write-off-loan')">Close</b-button>
          <b-button type="submit" class="btn ms-1 w-30" variant="primary"><i class="fas fa-check-circle"></i>
            YES</b-button>
        </div>
      </form>
    </b-modal>

    <b-modal id="get-excel-file" centered title="Running Loans Template" title-class="font-18" hide-footer>
      <form @submit.prevent="getExcelFile">
        <label>Loan Type</label>
        <v-select :options="loantypes" required placeholder="Select an Option" v-model="loantype" label="name"
          :reduce="loantype => loantype.id"></v-select>
        <hr>
        <div class="row align-items-center">
          <div class="col-3 border-end border-success">
            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="100" height="100" viewBox="0 0 48 48">
              <path fill="#4CAF50" d="M41,10H25v28h16c0.553,0,1-0.447,1-1V11C42,10.447,41.553,10,41,10z"></path>
              <path fill="#FFF"
                d="M32 15H39V18H32zM32 25H39V28H32zM32 30H39V33H32zM32 20H39V23H32zM25 15H30V18H25zM25 25H30V28H25zM25 30H30V33H25zM25 20H30V23H25z">
              </path>
              <path fill="#2E7D32" d="M27 42L6 38 6 10 27 6z"></path>
              <path fill="#FFF"
                d="M19.129,31l-2.411-4.561c-0.092-0.171-0.186-0.483-0.284-0.938h-0.037c-0.046,0.215-0.154,0.541-0.324,0.979L13.652,31H9.895l4.462-7.001L10.274,17h3.837l2.001,4.196c0.156,0.331,0.296,0.725,0.42,1.179h0.04c0.078-0.271,0.224-0.68,0.439-1.22L19.237,17h3.515l-4.199,6.939l4.316,7.059h-3.74V31z">
              </path>
            </svg>
          </div>
          <div class="col">
            <div><span class="fw-bold">File: </span> Running Loans Template</div>
            <br>
            <div>
              <div v-if="loader" class="progress">
                <div class="progress-bar" role="progressbar"> {{ progress }}% </div>
              </div>
              <div v-if="loader"><small class="text-success fw-bold">Generating file ....</small></div>
            </div>
          </div>

        </div>
        <br>
        <div class="d-flex justify-content-end">
          <button @click.prevent="$bvModal.hide('get-excel-file')" class="btn btn-outline-danger btn-sm fw-bold">Forget
            it</button>
          <button type="submit" :class="{ disabled: !loantype }"
            class="mx-3 btn btn-sm btn-success fw-bold">Download</button>
        </div>
      </form>
    </b-modal>


    <b-modal id="import-applications" centered title="Import Running Loans" title-class="font-18" hide-footer>
      <form @submit.prevent="importApplications" enctype="multipart/form-data">
        <label>Loan Type <small class="text-success">Check file</small></label>
        <v-select :options="loantypes" required placeholder="Select an Option" v-model="loantype" label="name"
          :reduce="loantype => loantype.id"></v-select>
        <hr>
        <div class="row align-items-center">
          <div class="col-3 border-end border-success">
            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="100" height="100" viewBox="0 0 48 48">
              <path fill="#4CAF50" d="M41,10H25v28h16c0.553,0,1-0.447,1-1V11C42,10.447,41.553,10,41,10z"></path>
              <path fill="#FFF"
                d="M32 15H39V18H32zM32 25H39V28H32zM32 30H39V33H32zM32 20H39V23H32zM25 15H30V18H25zM25 25H30V28H25zM25 30H30V33H25zM25 20H30V23H25z">
              </path>
              <path fill="#2E7D32" d="M27 42L6 38 6 10 27 6z"></path>
              <path fill="#FFF"
                d="M19.129,31l-2.411-4.561c-0.092-0.171-0.186-0.483-0.284-0.938h-0.037c-0.046,0.215-0.154,0.541-0.324,0.979L13.652,31H9.895l4.462-7.001L10.274,17h3.837l2.001,4.196c0.156,0.331,0.296,0.725,0.42,1.179h0.04c0.078-0.271,0.224-0.68,0.439-1.22L19.237,17h3.515l-4.199,6.939l4.316,7.059h-3.74V31z">
              </path>
            </svg>
          </div>
          <div class="col">
            <label for="">Upload Excel File</label>
            <input class="form-control" accept=".xls,.xlsx" type="file" @change.prevent="handleFileUpload"> <br>
            <!-- Progress bar -->
            <div v-if="uploading">
              <div class="progress">
                <div class="progress-bar" role="progressbar" :style="{ width: uploadProgress + '%' }"
                  :aria-valuenow="uploadProgress" aria-valuemin="0" aria-valuemax="100">
                  {{ uploadProgress }}%
                </div>
              </div>
            </div>
          </div>

        </div>
        <br>
        <div class="d-flex justify-content-end">
          <button @click.prevent="$bvModal.hide('import-applications')"
            class="btn btn-outline-danger btn-sm fw-bold">Forget
            it</button>
          <button type="submit" :class="{ disabled: !loantype }"
            class="mx-3 btn btn-sm btn-success fw-bold">Uplaod</button>
        </div>
      </form>
    </b-modal>

    <b-modal id="errors" title="Errors" centered title-class="font-18" hide-footer>
      <div class="text-danger">{{ errors }}</div>
    </b-modal>


  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { runningloanMethods, runningloanComputed, paymentoptionMethods, paymentoptionComputed, loantypeMethods, loantypeComputed } from "@/state/helpers";

export default {
  page: {
    title: "Running Loans",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "Running Loans",
      items: [
        { text: "Dashboard", to: "/" },
        { text: "Running Loans", active: true },
      ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
        { key: "index", label: "#", visible: true },
        { key: "id", label: "ID", visible: false },
        { key: "member", label: "Member", visible: true },
        { key: "loan_type", label: "Loan Product", visible: true },
        { key: "amount", label: "Loan", visible: true },
        // { key: 'payback', label: 'Payback', visible: true },
        { key: "interest", label: "Interest", visible: true },
        {
          key: "repaymentplan",
          label: "Repayment Plan",
          visible: true,
        },
        { key: "fine", label: "Fine/Day", visible: !JSON.parse(localStorage.getItem("user")).settings.combine_interest_fine },
        { key: "paid", label: "Paid", visible: true },
        { key: "balance", label: "Balance", visible: true },
        {
          key: "actions", label: "Actions", visible: (
            JSON.parse(localStorage.getItem("user")).permissions['reschedule_loan'] ||
            JSON.parse(localStorage.getItem("user")).permissions['write_off_loan']
          )
        },
        { key: "expirydate", label: "Full Repayment", visible: true },
      ],
      id: "",
      member: "",
      charges: "",
      disbursement_date: new Date().toLocaleDateString("fr-CA"),
      application_date: "",
      membername: "",
      payback: "",
      balance: "",
      rate: "",
      period: "",
      loan_rate: "",
      loan_period: "",
      loantype: "",
      interest: "",
      expirydate: new Date(),
      saveBtn: false,
      saveError: "",
      loan_id: "",
      paymentdate: new Date().toLocaleDateString("fr-CA"),
      amount: "",
      mode_of_payment: "",
      refference: "",
      currentdate: new Date().toLocaleDateString("fr-CA"),
      date_to: new Date().toLocaleDateString("fr-CA"),
      date_from: new Date().toLocaleDateString("fr-CA"),
      rescheduledate: new Date().toLocaleDateString("fr-CA"),
      reschedulereason: "",
      writeoffdate: new Date().toLocaleDateString("fr-CA"),
      writeoffreason: "",
      fine: "",
      total_loan: 0,
      loan: 0,
      bal_loan: 0,
      bal_interest: 0,
      bal_fine: 0,
      extra_change: 0,
      change: 0,
      change1: 0,
      paid: 0,
      total_paid: 0,
      loader: false,
      progress: 0,
      import_file: '',
      errors: '',
      uploading: false,
      uploadProgress: 0,
      name_hover: false,
      current_index: '',
    };
  },
  computed: {
    ...loantypeComputed,
    ...runningloanComputed,
    ...paymentoptionComputed,

    List() {
      return this.runningloans.length;
    },
    Fields() {
      return this.fields.filter((field) => field.visible);
    },
    Items() {
      return this.runningloans.map((d) => ({ ...d }));
    },
    IsBusy() {
      let a = false;
      if (this.runningloans.length > 0) {
        a = false;
      } else {
        a = true;
      }
      return a;
    },
    totalloan() {
      var total = 0;
      this.runningloans.forEach((item) => {
        var item_total = item.amount;
        total = Number(total) + Number(item_total);
      });
      return total;
    },
    totalpaid() {
      var total = 0;
      this.runningloans.forEach((item) => {
        var item_total = item.paid;
        total = Number(total) + Number(item_total);
      });
      return total;
    },
  },
  mounted() {
    this.fetchLoanTypes();
    this.fetchRunningLoans();
    this.fetchPaymentoptions();
    this.TotalRows = this.runningloans.length;
    this.isBusy = false;
  },
  methods: {
    ...loantypeMethods,
    ...runningloanMethods,
    ...paymentoptionMethods,
    commas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },

    payFunction() {
      this.bal_interest = this.interest - this.amount - this.paid;
      this.bal_loan = this.loan;
      this.bal_fine = this.fine;
      this.extra_change = 0;
      if (this.bal_interest <= 0) {
        this.change = this.paid + Number(this.amount) - this.interest;
        this.bal_interest = 0;

        this.bal_loan = this.loan - this.change;
        if (this.bal_loan <= 0) {
          this.bal_loan = 0;
          this.change1 = this.change - this.loan;

          this.bal_fine = this.fine - this.change1;
          if (this.bal_fine <= 0) {
            this.bal_fine = 0;
            this.extra_change = this.change1 - this.fine;
          }
        }
      }
    },

    payaLoan(id, member, amount, interest, fine, paid) {
      (this.bal_loan = amount),
        (this.bal_interest = interest),
        (this.bal_fine = fine),
        (this.extra_change = 0),
        (this.change = 0),
        (this.change1 = 0),
        (this.loan_id = id);
      this.total_loan =
        Number(amount) + Number(interest) + Number(fine) - Number(paid);
      this.member = member.member_id;
      this.membername = member.name;
      this.loan = amount;
      this.fine = fine;
      this.interest = interest;
      this.paid = paid;
      this.$bvModal.show("repay-loan");
      this.payFunction();
    },
    closeloan(id, member, amount) {
      this.id = id;
      this.membername = member;
      this.amount = amount;
      this.$bvModal.show("close-a-loan");
    },
    writeoff(id, member, amount) {
      this.id = id;
      this.membername = member;
      this.amount = amount;
      this.$bvModal.show("write-off-loan");
    },
    reschedule(id, member, amount) {
      this.id = id;
      this.membername = member;
      this.amount = amount;
      this.$bvModal.show("reschedule-a-loan");
    },
    async repayaLoan() {
      this.saveBtn = true;
      this.saveError = "Saving Loan Repayment";
      if (!this.mode_of_payment) {
        this.saveError = "Please select a mode of payment";
        this.$toast.error('Please select a mode of payment');
        this.saveBtn = false;
        return;
      }

      let formData = new FormData();
      formData.append("member", this.member);
      formData.append("loan", this.loan_id);
      formData.append("amount", this.amount);
      formData.append("interest", this.interest);
      formData.append("mode_of_payment", this.mode_of_payment);
      formData.append("refference", this.refference);
      formData.append("date_of_payment", this.paymentdate);
      let url = "/repayaloan";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchRunningLoans();
          this.member = "";
          this.loan_id = "";
          this.amount = "";
          this.refference = "";
          this.saveBtn = false;
          this.saveError = "";
          this.$bvModal.hide("repay-loan");
        }
      });
    },
    async Close_a_Loan() {
      let formData = new FormData();
      formData.append("id", this.id);
      let url = "/closerunningloans";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchRunningLoans();
          this.$bvModal.hide("close-a-loan");
        }
      });
    },
    async Write_off_Loan() {
      let formData = new FormData();
      formData.append("id", this.id);
      formData.append("reason", this.writeoffreason);
      formData.append("date", this.writeoffdate);
      let url = "/writeoffrunningloans";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchRunningLoans();
          this.writeoffreason = "";
          this.$bvModal.hide("write-off-loan");
        }
      });
    },
    async Reschedule_a_Loan() {
      let formData = new FormData();
      formData.append("id", this.id);
      formData.append("date", this.rescheduledate);
      formData.append("reason", this.reschedulereason);
      let url = "/reschedulerunningloans";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchRunningLoans();
          this.reschedulereason = "";
          this.$bvModal.hide("reschedule-a-loan");
        }
      });
    },

    getExcelModal() {
      this.loantype = '';
      this.application_date = new Date().toLocaleDateString('fr-CA');
      this.$bvModal.show('get-excel-file');
    },

    async getExcelFile() {
      this.loader = true;
      this.progress = 0;
      let formData = new FormData();
      formData.append('loan_type', this.loantype);
      let url = 'download-running-template';


      await axios.post(url, formData, {
        onDownloadProgress: (progressEvent) => {
          this.progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        },
        responseType: 'blob', // To handle the file download
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'Running_Loans.xlsx'); // Replace with your desired file name
        document.body.appendChild(link);
        link.click();
        link.remove();
      }).catch((error) => {
        alert('Error downloading file:', error);
      }).finally(() => {
        this.loader = false;
      });
    },

    getImportModal() {
      this.loantype = '';
      this.application_date = new Date().toLocaleDateString('fr-CA');
      this.$bvModal.show('import-applications');
    },

    handleFileUpload(event) {
      this.import_file = event.target.files[0]
    },

    async importApplications() {

      if (!this.import_file) {
        alert('Please select a file.');
        return;
      }
      this.uploadProgress = 0;
      this.uploading = true
      this.errors = ''
      let url = '/import-running'
      let obj = {
        loan_type: this.loantype,
        file: this.import_file
      }

      await axios.post(url, obj, {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: progressEvent => {
          this.uploadProgress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        },
      }).then(response => {
        if (response.data.success) {
          this.$toast.success(response.data.success)
          this.selectedFile = 0;
          this.uploadProgress = 0;
          this.fetchRunningLoans();
        }
        else {
          this.errors = response.data.errors || 'Error occured!'
          this.$bvModal.show('errors')
          this.uploadProgress = 0;
        }
      });
    },

    FilterData() {
      this.filterRunningLoans({
        datefrom: this.date_from,
        dateto: this.date_to,
      });
    },
  },
};
</script>
